// src/hooks/useUserProfile.js 
import { useEffect, useState } from "react";
import { db } from "../../components/firebase";
import { doc, getDoc } from "firebase/firestore";

const cache = new Map();

export default function useUserProfile(userId) {
  // берём только setProfile, первый элемент нам не нужен
  const [, setProfile] = useState(cache.get(userId) || null);

  useEffect(() => {
    let mounted = true;
    if (!userId || cache.has(userId)) return;

    (async () => {
      try {
        const snap = await getDoc(doc(db, "users", userId));
        const data = snap.exists() ? snap.data() : null;
        const norm = data
          ? {
              displayName:
                data.displayName ||
                (data.email ? data.email.split("@")[0] : "Unknown"),
              email: data.email || null,
              avatar: data.avatar || null,
            }
          : null;
        cache.set(userId, norm);
        if (mounted) setProfile(norm);   // теперь это нормальный сеттер
      } catch {
        if (mounted) setProfile(null);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [userId, setProfile]);

  // читаем из cache, как и раньше
  return { profile: cache.get(userId) || null };
}

